import { cn } from '@/lib/utils'
import { Button } from './ui/button'
import useAbility from '@/hooks/use-ability'
import { useMemo } from 'react'
import { siteConfig } from '@/config/site'
import { useNavigate } from 'react-router-dom'

interface Props {
  needUpgrade: boolean
  title: string
  className?: string
  position?: string
  clnButton: string
  onClickOutside?: () => void
  onMouseOver?: () => void
  onMouseOut?: () => void
}

export default function UpgradeLayout({
  title,
  needUpgrade,
  className = '',
  position = '',
  clnButton = '',
  onClickOutside,
  onMouseOver,
  onMouseOut,
}: Props) {
  const navigate = useNavigate()
  const isDemoUser = useMemo(() => {
    const authData = localStorage.getItem('auth')
    return (
      authData &&
      JSON.parse(authData).sessionKey === 'a6cf9f6e-3341-4996-8d6a-83e826b67adf'
    )
  }, [])
  const isTutorialPage = window.location.pathname === '/tutorial'
  const { isLoading } = useAbility()
  if (isTutorialPage) return null
  if (isDemoUser) return null
  if (!needUpgrade) return null
  if (isLoading) return null

  return (
    <div className={cn('absolute z-20 w-full h-full', position)}>
      <div
        onClick={() => {
          onClickOutside && onClickOutside()
        }}
        onMouseOver={onMouseOver}
        onMouseOut={onMouseOut}
        className={cn(
          'flex flex-col items-center justify-center w-full h-full bg-white gap-4 px-4',
          className,
          {
            'cursor-pointer': onClickOutside !== undefined,
          }
        )}
      >
        {title && <span className="text-center break-words">{title}</span>}
        <Button
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            navigate(siteConfig.upgradeUrl)
          }}
          className={(cn('max-w-[154px]'), clnButton)}
          size={'md'}
        >
          Upgrade
        </Button>
      </div>
    </div>
  )
}
